var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"pax-loading-modal"},[_c('div',{staticClass:"pax-loading-modal__spinner"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }